import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/LevelUpSettingsQuery.graphql';

export const levelUpSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-level-up-settings-entrypoint" */ './LevelUpSettings.tsx'),
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (!projectKey) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				levelUpSettingsData: {
					parameters,
					variables: {
						cloudId,
						projectKey,
						siteAri: `ari:cloud:jira::site/${cloudId}`,
					},
				},
			},
			extraProps: {},
		};
	},
});
